import React from 'react';
import './finalCTA.css'

const FinalCTA = () => {
    return (
        <section id="free-trial-block">
            <div className="container">
                <div className="row wow fadeInUp">
                    <p data-testid="paragraph">Want to be a part of the team? We are always looking for new talent.</p>
                    <a data-testid="button" href="contact.html">Submit Resume</a> </div>
            </div>
        </section>
    )
}
export default FinalCTA;